import { Component, OnInit, Renderer2, AfterViewInit, OnDestroy, ViewChild, Input } from '@angular/core';
import { Router } from '@angular/router';
import Swal from 'sweetalert2';
import { ToastrService } from 'ngx-toastr';
import { DataTableDirective } from 'angular-datatables';
import { Subject } from 'rxjs';
import { UserService } from 'src/app/services/user.service';
import { FormControl, FormGroup } from '@angular/forms';

import { Status } from 'src/app/enums/status';
import * as Highcharts from 'highcharts';
import { HighchartsOptions } from 'src/app/config/highcharts-config';
import * as moment from 'moment';
import { formatDate } from '@angular/common';
import { saveAs } from 'file-saver';
import { AdvExpenseBudgetResult, AdvExpenseDashBoard, AdvExpenseFilters, SelectListParams } from 'src/app/models/stihl-adv-expense-dto';
import { AdvExpenseService } from 'src/app/services/adv-expense.service';
import { SharedService } from 'src/app/services/shared.service';
import { LanguageApp } from 'src/app/config/datatable-config';
import { visibleContentAnimation } from 'src/app/animations';


@Component({
  selector: 'expenses-dashboard',
  templateUrl: './expenses-dashboard.component.html',
  styleUrls: ['./expenses-dashboard.component.scss'],
  animations: [visibleContentAnimation]
})
export class ExpensesDashboardComponent implements AfterViewInit, OnDestroy, OnInit {

  @ViewChild(DataTableDirective, { static: false })

  dtElement: DataTableDirective;
  dtOptions: DataTables.Settings = {};
  dtTrigger: Subject<any> = new Subject();
  public distributorsList: any[] = [];
  public districtsList: any[] = [];
  public districtsManagersList: any[] = [];
  @Input() idDistrib;
  @Input() zone;
  @Input() isAdminOrIntern = false;
  public campaignTypes: any[] = [];
  public medias: any[] = [];
  public formats: any[] = [];
  public supports: any[] = [];
  public status: any[] = [];
  public meses: any[] = [];
  public anios: any[] = [];
  distributorDefaultValue = '0';
  districtManagerDefaultValue;
  districtDefaultValue;
  statusDefaultValue;
  campaignTypeDefaultValue;
  mediaDefaultValue;
  formatDefaultValue;
  supportDefaultValue;
  monthDefaultValue;
  yearDefaultValue;
  dashboardModel: AdvExpenseDashBoard = new AdvExpenseDashBoard();
  filter: AdvExpenseFilters = new AdvExpenseFilters({});
  initDate: string;
  endDate: string;
  listenerFn: () => void;
  tableFilter = JSON.stringify([this.filter]);
  articulo = "";
  dataCount = 0;
  idColumnNumber: number;
  disableDistributor = false;
  disableDistrict = false;
  disableDistrictManager = false;
  budgetModel: AdvExpenseBudgetResult = new AdvExpenseBudgetResult();
  budgetModelLastYear: AdvExpenseBudgetResult = new AdvExpenseBudgetResult();
  showBudget;
  yearBudget = new Date().getFullYear().toString();
  showBudgetLastYear = false;
  yearBudgetLastYear;
  currentMonth = 0;
  yearMonthlyExcelSelected;
  yearMonthlyExcelData;
  filterBudgetStatus: AdvExpenseFilters = new AdvExpenseFilters({});

  public optionCampaignTypeChart: any = {
    chart: {
      plotBackgroundColor: null,
      plotBorderWidth: null,
      plotShadow: false,
      type: 'column'
    },
    title: {
      text: '<b>CAMPANHAS</b>'
    },
    credits: {
      enabled: false
    },
    tooltip: {
      pointFormat: '<b>{point.y:.1f}%</b>'
    },
    accessibility: {
      point: {
        valueSuffix: '%'
      }
    },
    xAxis: {
      lineColor: '#DADADA',
      title: {
        text: ''
      },
      labels: {
        enabled: false
      }
    },
    yAxis: {
      title: {
        text: 'Percentagem %'
      },
      point: {
        valueSuffix: '%'
      }
    },
    legend: {
      enabled: false
    },
    plotOptions: {
      column: {
        allowPointSelect: true,
        cursor: 'pointer',
        dataLabels: {
          enabled: true,
          format: '{point.name}</br> {point.y:.1f} %'
        }
      }
    },
    series: [{
      name: '',
      colorByPoint: true,
      data: []
    }]
  };
  public optionMediaChart: any = {
    chart: {
      plotBackgroundColor: null,
      plotBorderWidth: null,
      plotShadow: false,
      type: 'column'
    },
    title: {
      text: '<b>MATERIAIS</b>'
    },
    credits: {
      enabled: false
    },
    tooltip: {
      pointFormat: '<b>{point.y:.1f}%</b>'
    },
    accessibility: {
      point: {
        valueSuffix: '%'
      }
    },
    xAxis: {
      lineColor: '#DADADA',
      title: {
        text: ''
      },
      labels: {
        enabled: false
      }

    },
    yAxis: {
      title: {
        text: 'Percentagem %'
      },
      point: {
        valueSuffix: '%'
      }
    },
    legend: {
      enabled: false
    },
    plotOptions: {
      column: {
        allowPointSelect: true,
        cursor: 'pointer',
        dataLabels: {
          enabled: true,
          format: '{point.name}</br> {point.y:.1f} %'
        }
      }
    },
    series: [{
      name: 'MATERIAIS',
      colorByPoint: true,
      data: []
    }]
  };
  public optionFormatChart: any = {
    chart: {
      plotBackgroundColor: null,
      plotBorderWidth: null,
      plotShadow: false,
      type: 'column'
    },
    title: {
      text: '<b>FORMATOS</b>'
    },
    credits: {
      enabled: false
    },
    tooltip: {
      pointFormat: '<b>{point.y:.1f} %</b>'
    },
    accessibility: {
      point: {
        valueSuffix: '%'
      }
    },
    xAxis: {
      lineColor: '#DADADA',
      title: {
        text: ''
      },
      labels: {
        enabled: false
      }

    },
    yAxis: {
      title: {
        text: 'Percentagem %'
      },
      point: {
        valueSuffix: '%'
      }
    },
    legend: {
      enabled: false
    },
    plotOptions: {
      column: {
        allowPointSelect: true,
        cursor: 'pointer',
        dataLabels: {
          enabled: true,
          format: '{point.name}<br/> {point.y:.1f} %'
        }
      }
    },
    series: [{
      name: 'FORMATO',
      colorByPoint: true,

    }]
  };
  public optionSupportChart: any = {
    chart: {
      plotBackgroundColor: null,
      plotBorderWidth: null,
      plotShadow: false,
      type: 'column'
    },
    title: {
      text: '<b>MEIO</b>'
    },
    credits: {
      enabled: false
    },
    tooltip: {
      pointFormat: ' <b>{point.y:.1f} %</b>'
    },
    accessibility: {
      point: {
        valueSuffix: '%'
      }
    },
    xAxis: {
      lineColor: '#DADADA',
      title: {
        text: ''
      },
      labels: {
        enabled: false
      }

    },
    yAxis: {
      title: {
        text: 'Percentagem %'
      },
      point: {
        valueSuffix: '%'
      }
    },
    legend: {
      enabled: false
    },
    plotOptions: {
      column: {
        allowPointSelect: true,
        cursor: 'pointer',
        dataLabels: {
          enabled: true,
          format: '{point.name}<br/> {point.y:.1f} %'
        }
      }
    },
    series: [{
      name: 'MEIO',
      colorByPoint: true,
      data: []
    }]
  };

  constructor(
    private advExpensesService: AdvExpenseService,
    private sharedService: SharedService,
    private router: Router,
    private renderer: Renderer2,
    private userService: UserService,
    private toastr: ToastrService) {
  }

  ngAfterViewInit(): void {

    this.dtTrigger.next(null);
    this.listenerFn = this.renderer.listen('document', 'click', (event) => {

      if (this.idDistrib === undefined) {

        if (event.target.hasAttribute("edit-expense-id")) {
          this.router.navigate(["area-stihl/adv-expense/edit/" + event.target.getAttribute("edit-expense-id")]);
        } else if (event.target.hasAttribute("delete-expense-id")) {
          this.delete(event.target.getAttribute("delete-expense-id"));
        }

      } else {

        if (event.target.hasAttribute("edit-expense-id")) {
          this.router.navigate(["/adv-expense/edit/" + event.target.getAttribute("edit-expense-id")]);
        } else if (event.target.hasAttribute("delete-expense-id")) {
          this.delete(event.target.getAttribute("delete-expense-id"));
        }

      }

    });
  }

  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
    if (this.listenerFn) {
      this.listenerFn();
    }
  }

  rerender(): void {
    this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
      dtInstance.draw();
    });
  }

  ngOnInit(): void {

    this.getData();
    this.GetYearMonhlyExcel();

    // this.getData();

    if (this.idDistrib !== undefined) {
      this.disableDistributor = true;
      this.disableDistrict = true;
      this.disableDistrictManager = true;
      this.filter.IdDistributor = this.idDistrib;
      this.tableFilter = JSON.stringify([this.filter]);
      this.articulo = "AS MINHAS"
    } else {
      this.articulo = "AS"
    }

    this.setDatatable();
  }

  //#region DATATABLE

  setDatatable() {
    const that = this;
    this.dtOptions = {
      ajax: (dataTablesParameters: any, callback) => {
        that.advExpensesService.GetDatatable(dataTablesParameters, this.tableFilter).subscribe(resp => {
          callback({
            recordsTotal: resp.recordsTotal,
            recordsFiltered: resp.recordsFiltered,
            data: this.CustomData(resp.data)
          });
        }, (err) => {
          Swal.fire({
            icon: 'error',
            title: 'Erro ao recuperar os dados',
            text: 'Ocorreu um erro'
          });

        });
      },
      columns: this.setColumns(),
      columnDefs: [
        {
          targets: [2],
          data: "Period",
          render: function (data, type, full) {
            var retorno = "";
            retorno = 'Início: <div class="green">' + data.InitDate + '</div> Fim: <div class="red">' + data.EndDate + '</div>';
            return retorno;
          }
        },
        {
          targets: [6],
          data: "Status",
          render: function (data, type, full) {
            var retorno = "";
            retorno += "<span id='txtStatus_" + full.IdAdvExpense + "'></span>"
            return retorno;
          }
        },
        {
          targets: [9],
          data: "ExpectedAmountRead",
          render: function (data, type, full) {
            // Asegúrate de que data sea una cadena válida antes de realizar la manipulación
            if (typeof data === 'string') {
              // Agrega un espacio después del símbolo de la moneda
              data = data.replace('€', ' €');
            }
            // Devuelve la cadena modificada o la original
            return data;
          }
        },
        {
          targets: [10],
          data: "InvoiceAmountRead",
          render: function (data, type, full) {
            // Asegúrate de que data sea una cadena válida antes de realizar la manipulación
            if (typeof data === 'string') {
              // Agrega un espacio después del símbolo de la moneda
              data = data.replace('€', ' €');
            }
            // Devuelve la cadena modificada o la original
            return data;
          }
        },
        {
          targets: [this.idDistrib === undefined ? this.idColumnNumber - 1 : null],
          data: "Status",
          render: function (data, type, full) {
            var retorno = "";
            retorno += "<span id='txtBonus_" + full.IdAdvExpense + "'></span>";
            return retorno;
          }
        },
        {
          targets: [this.idColumnNumber],
          data: "IdAdvExpense",
          className: "text-end",
          render: function (data, type, full) {
            var retorno = "";
            // retorno += '<div class="ico-opciones_content cursor-pointer"><div edit-expense-id="' + data + '" class="icoEye ico-opciones" title="Ver/Editar"></div><div edit-expense-id="' + data + '" class="text-orange ico-opciones">Ver</div></div>';
            retorno += '<a edit-expense-id="' + data + '" class="btn-transparent btn-sm btn-icon"><div class="svg-icon"><svg viewBox="0 0 150 150"><use xlink:href="assets/images/icons/ico_eye_auto.svg#img" href="assets/images/icons/ico_eye_auto.svg#img"></use></svg></div> Ver</a>';

            if (that.idDistrib === undefined) {

              if (that.isAdminOrIntern)
                // retorno += '<div class="ico-opciones_content cursor-pointer"><div delete-expense-id="' + data + '"class="icoDelet ico-opciones" title="Eliminar"></div><div delete-expense-id="' + data + '" class="text-orange ico-opciones">ELIMINAR</div></div>';
                retorno += '<a delete-expense-id="' + data + '" class="btn-transparent btn-sm btn-icon"><div class="svg-icon"><svg viewBox="0 0 150 150"><use xlink:href="assets/images/icons/ico_trash_auto.svg#img" href="assets/images/icons/ico_trash_auto.svg#img"></use></svg></div> Eliminar</a>';

            } else {

              if (full.IdStatus == Status.GastoPendienteAprobacion)
                // retorno += '<div class="ico-opciones_content cursor-pointer" ><div delete-expense-id="' + data + '"class="icoDelet ico-opciones" title="Eliminar"></div><div delete-expense-id="' + data + '" class="text-orange strong ico-opciones">ELIMINAR</div></div>';
                retorno += '<a delete-expense-id="' + data + '" class="btn-transparent btn-sm btn-icon"><div class="svg-icon"><svg viewBox="0 0 150 150"><use xlink:href="assets/images/icons/ico_trash_auto.svg#img" href="assets/images/icons/ico_trash_auto.svg#img"></use></svg></div> Eliminar</a>';
            }

            //if (full.OriginalInvoiceUri)
            //  retorno += '<a  href="' + full.OriginalInvoiceUri + '" class="btn-transparent btn-sm btn-icon"><div class="svg-icon"><svg viewBox="0 0 150 150"><use xlink:href="assets/images/icons/ico_download_auto.svg#img" href="assets/images/icons/ico_download_auto.svg#img"></use></svg></div> Factura</a>';

            return retorno;

          }
        }
      ],
      responsive: true,
  autoWidth: false,
  scrollX: false,
  scrollCollapse: true,
      paging: true,
      pageLength: 10,
      ordering: true,
      lengthChange: false,
      info: false,
      serverSide: true,
      language: LanguageApp.spanish_datatables,
      processing: true
    };
  }
  setColumns() {

    if (this.idDistrib === undefined) {
      this.idColumnNumber = 13;
      return [
        { data: "CodDistributor", orderable: false, class: "text-center" },
        { data: "Distributor", orderable: false, class: "text-center" },
        { data: "Period", orderable: false, class: "text-center" },
        { data: "CreationDate", orderable: false, class: "text-center" },
        { data: "ValidationDate", orderable: false, class: "text-center" },
        { data: "PaymentDate", orderable: false, class: "text-center" },
        { data: "Status", orderable: false, class: "text-center" },
        { data: "Campaign", orderable: false, class: "text-center" },
        { data: "CreativePieceType", orderable: false, class: "text-center" },
        { data: "ExpectedAmountRead", orderable: false, class: "text-center" },
        { data: "InvoiceAmountRead", orderable: false, class: "text-center" },
        { data: "BudgetYear", orderable: true, name: "BudgetYear", class: "text-center" },
        { data: "BonusAmountRead", orderable: false, class: "text-center" },
        { data: "IdAdvExpense", orderable: false }
      ]
    } else {
      this.idColumnNumber = 11;
      return [
        { data: "CodDistributor", orderable: false, class: "text-center" },
        { data: "Distributor", orderable: false, class: "text-center" },
        { data: "Period", orderable: false, class: "text-center" },
        { data: "CreationDate", orderable: false, class: "text-center" },
        { data: "ValidationDate", orderable: false, class: "text-center" },
        { data: "PaymentDate", orderable: false, class: "text-center" },
        { data: "Status", orderable: false, class: "text-center" },
        { data: "Campaign", orderable: false, class: "text-center" },
        { data: "CreativePieceType", orderable: false, class: "text-center" },
        { data: "ExpectedAmountRead", orderable: false, class: "text-center" },
        { data: "InvoiceAmountRead", orderable: false, class: "text-center" },
        { data: "IdAdvExpense", orderable: false }
      ]
    }
  }

  CustomData(obj: any[]) {
    const that = this;


    obj.forEach(function (dataB) {


      if (dataB.BudgetYear != null) {
        var firstDay = new Date(dataB.BudgetYear, 0, 1);
        that.filterBudgetStatus.InitDate = formatDate(firstDay, 'yyyy-MM-dd', 'en-US');
      } else {
        var firstDay = new Date();
        that.filterBudgetStatus.InitDate = formatDate(firstDay, 'yyyy-MM-dd', 'en-US');
      }

      that.filterBudgetStatus.IdDistributor = dataB.IdDistributor;

      that.advExpensesService.GetBudgetData(that.filterBudgetStatus).subscribe((resp) => {


        var id = "txtStatus_" + dataB.IdAdvExpense;
        var element = document.getElementById(id);
        if (element != null) {
          if (resp.SpentConfPercent && resp.SpentConfPercent == 100) {
            element.innerHTML = '<div class="status' + dataB.IdStatus + '">' + dataB.Status + ' (budget anual alcançado)' + '</div>';
          } else {
            element.innerHTML = '<div class="status' + dataB.IdStatus + '">' + dataB.Status + '</div>';
          }
        }


        var id = "txtBonus_" + dataB.IdAdvExpense;
        var element = document.getElementById(id);
        if (element != null) {
          const bonusText = that.formatAmountPt(resp.RemainConfString);
          element.innerHTML = '<div >' + (bonusText !== '' ? bonusText + ' €' : '') + '</div>';
        }

      });


    });

    return obj;
  }

  /** Formato pt-PT: separador de miles y coma decimal (ej. 1 234,56). */
  private formatAmountPt(value: unknown): string {
    if (value === null || value === undefined) {
      return '';
    }
    const n = this.parseAmountNumber(value);
    if (n === null) {
      return String(value).trim();
    }
    return new Intl.NumberFormat('pt-PT', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format(n);
  }

  private parseAmountNumber(value: unknown): number | null {
    if (typeof value === 'number' && !Number.isNaN(value)) {
      return value;
    }
    let s = String(value).replace(/€/g, '').replace(/\s/g, '').trim();
    if (!s) {
      return null;
    }
    const lastComma = s.lastIndexOf(',');
    const lastDot = s.lastIndexOf('.');
    if (lastComma > lastDot) {
      s = s.replace(/\./g, '').replace(',', '.');
    } else {
      s = s.replace(/,/g, '');
    }
    const n = parseFloat(s);
    return Number.isNaN(n) ? null : n;
  }

  changeStatus(id, status) {
    this.advExpensesService.changeStatus(id, status).subscribe(() => { }, (err) => {
      Swal.fire({
        icon: 'error',
        title: 'Erro ao recuperar os dados',
        text: 'Ocorreu um erro'
      });
    });
  }

  delete(id) {
    Swal.fire({
      title: 'Deseja remover esta despesa?',
      text: "A despesa já não pode ser processada",
      icon: 'warning',
      showCancelButton: true,
      buttonsStyling: false,
      customClass: {
        cancelButton: 'btn-orange-border mx-1',
        confirmButton: 'btn-orange mx-1'
      },
      allowOutsideClick: false,
      confirmButtonText: 'Eliminar',
      cancelButtonText: 'Cancelar',
      reverseButtons: true
    }).then((result) => {
      if (result.value) {
        this.advExpensesService.changeStatus(id, Status.Baja).subscribe(() => {
          this.toastr.success("A despesa foi removida com sucesso");
          this.rerender();
        }, (err) => {
          Swal.fire({
            icon: 'error',
            title: 'Erro ao eliminar o item',
            text: 'Ocorreu um erro'
          });
        });
      }
    })
  }

  //#endregion


  getData() {

    //this.getDashboard();
    this.getDistrictsManagers();
    this.getStatus();
    this.getYearsAndMonth();

  }

  getDashboard(data?) {

    if (data) {
      this.tableFilter = JSON.stringify([this.filter]);
      this.rerender();
    }

    this.advExpensesService.GetDashboard(this.filter).subscribe(res => {

      this.dashboardModel = res;

      this.optionCampaignTypeChart.series[0].data = [];
      this.dashboardModel.CampaignTypeCharts.forEach(elem => {

        this.optionCampaignTypeChart.series[0].data.push({ name: elem.Name, y: elem.Percentage });

      });

      this.optionMediaChart.series[0].data = [];
      this.dashboardModel.MediaCharts.forEach(elem => {

        this.optionMediaChart.series[0].data.push({ name: elem.Name, y: elem.Percentage });

      });

      this.optionFormatChart.series[0].data = [];
      this.dashboardModel.FormatCharts.forEach(elem => {

        this.optionFormatChart.series[0].data.push({ name: elem.Name, y: elem.Percentage });

      });

      this.optionSupportChart.series[0].data = [];
      this.dashboardModel.SupportCharts.forEach(elem => {

        this.optionSupportChart.series[0].data.push({ name: elem.Name, y: elem.Percentage });

      });

      Highcharts.setOptions(HighchartsOptions.highcharts_options);
      Highcharts.chart('chartCampaignType', this.optionCampaignTypeChart);
      Highcharts.chart('chartMedia', this.optionMediaChart);
      Highcharts.chart('chartFormat', this.optionFormatChart);

      this.getBudgetData();

    });
  }

  DownloadExcel() {

    Swal.fire({
      allowOutsideClick: false,
      icon: 'info',
      text: 'Aguarde por favor…'
    });

    Swal.showLoading();

    this.advExpensesService.DownloadExcel(this.filter).subscribe(blob => {
      Swal.close();
      saveAs(blob, "despesas-publicidade.xlsx");
    }), (err) => {
      Swal.fire({
        icon: 'error',
        title: 'Erro ao aceder á Base de Dados',
        text: 'Ocorreu um erro'
      });
    }
  }


  //#region SELECT-LISTS

  getDistributors(data: SelectListParams) {

    this.advExpensesService.GetDistributorDashboard(data).subscribe(res => {

      res.sort(function (a, b) {
        if (a.label > b.label) {
          return 1;
        }
        if (a.label < b.label) {
          return -1;
        }
        return 0;
      });

      let distribIdes = res.map(x => x.value);

      res.unshift({ value: '0', idParent: null, label: 'TODOS OS CONCESSIONÁRIOS' });
      this.distributorsList = res;


      this.distributorDefaultValue = this.idDistrib !== undefined ? this.idDistrib.toString() : '0';


      if (this.idDistrib === undefined)
        this.filter.IdDistributor = null;


      if (this.idDistrib === undefined) {
        this.getCampaignType(new SelectListParams({ IdDistrib: distribIdes }));
        this.getMedia(new SelectListParams({ IdDistrib: distribIdes }));
        this.getFormat(new SelectListParams({ IdDistrib: distribIdes }));
        // this.getSupport(new SelectListParams({ IdDistrib: distribIdes }));
      } else {
        this.getDistribValue({ option: { value: this.filter.IdDistributor.toString() } });
      }
      this.dataCount++;

      if (this.dataCount == 2) {

        setTimeout(() => {
          this.getDashboard(true);
        }, 1000);


      }

    });

  }

  getDistribValue(event) {

    this.filter.IdDistributor = event.option.value != '0' ? +event.option.value : null;

    if (event.option.value != '0') {
      this.districtDefaultValue = this.distributorsList.find(x => x.value == event.option.value).idParent.toString();
      this.filter.DistrictCode = [this.districtDefaultValue];
      this.districtManagerDefaultValue = this.districtsManagersList.find(x => x.districts.includes(+this.districtDefaultValue)).value.toString()
    }

    this.getCampaignType(new SelectListParams({ IdDistrib: this.filter.IdDistributor != null ? [this.filter.IdDistributor] : [] }));
    this.getMedia(new SelectListParams({ IdDistrib: this.filter.IdDistributor != null ? [this.filter.IdDistributor] : [] }));
    this.getFormat(new SelectListParams({ IdDistrib: this.filter.IdDistributor != null ? [this.filter.IdDistributor] : [] }));
    // this.getSupport(new SelectListParams({ IdDistrib: this.filter.IdDistributor != null ? [this.filter.IdDistributor] : [] }));

  }

  getDistricts(data) {

    this.advExpensesService.GetDistrictDashboard(data).subscribe(res => {

      res.sort(function (a, b) {
        if (a.label > b.label) {
          return 1;
        }
        if (a.label < b.label) {
          return -1;
        }
        return 0;
      });

      let result = [];
      result.push({ value: '0', idParent: null, label: 'TODOS AS ZONAS' });
      this.districtDefaultValue = this.zone !== undefined ? res.find(x => x.value == this.zone).value.toString() : '0';
      result.push.apply(result, res);
      this.districtsList = result;

      this.dataCount++;

      if (this.dataCount == 2) {

        setTimeout(() => {
          this.getDashboard(true);
        }, 1000);


      }

    });

  }

  getDistrictValue(event) {

    if (event.option.value != '0') {

      this.districtManagerDefaultValue = this.districtsManagersList.find(x => x.districts.includes(+event.option.value)).value.toString()

      this.filter.DistrictCode = [event.option.value]
    }

    else {
      this.filter.DistrictCode = this.districtManagerDefaultValue == '0' ? [] : this.districtsManagersList.find(x => x.value == this.districtManagerDefaultValue).districts;

    }

    this.getDistributors(new SelectListParams({ districtCode: this.filter.DistrictCode }));

  }

  getDistrictsManagers() {

    this.advExpensesService.GetDistrictManagerDashboard().subscribe(res => {

      res.sort(function (a, b) {
        if (a.label > b.label) {
          return 1;
        }
        if (a.label < b.label) {
          return -1;
        }
        return 0;
      });

      let result = [];
      result.push({ value: '0', districts: [], label: 'TODOS OS CHEFES DE ZONA' });
      this.districtManagerDefaultValue = this.zone !== undefined ? res.find(x => x.districts.includes(this.zone)).value.toString() : '0';


      result.push.apply(result, res);
      this.districtsManagersList = result;

      this.getDistricts(new SelectListParams({}));
      this.getDistributors(new SelectListParams({}));

    });

  }

  getDistrictManagersValue(event) {

    let districtList = event.option.value != '0' ? this.districtsManagersList.find(x => x.value == event.option.value).districts : [];
    this.filter.DistrictCode = districtList;

    this.getDistricts(new SelectListParams({ districtCode: this.filter.DistrictCode }));
    this.getDistributors(new SelectListParams({ districtCode: this.filter.DistrictCode }));


  }

  getYearsAndMonth() {
    this.advExpensesService.getAdvExpenseYears().subscribe(res => {
      res.unshift({ value: '0', label: 'TODOS OS ANOS' })
      this.yearDefaultValue = '0';
      this.anios = res;
    })
    this.sharedService.getStihAllMonth().subscribe(res => {
      res.unshift({ value: '0', label: 'TODOS OS MESES' })
      this.monthDefaultValue = '0';
      this.meses = res;
    })
  }

  getMonthValue(event) {

    this.monthDefaultValue = event.option.value;

    if (this.yearDefaultValue == '0') {

      this.yearDefaultValue = new Date().getFullYear().toString();

    }

    if (event.option.value == '0') {

      if (this.yearDefaultValue != '0') {

        var firstDay = new Date(+this.yearDefaultValue, 0, 1);
        var lastDay = new Date(+this.yearDefaultValue, 11, 31);

        this.filter.InitDate = formatDate(firstDay, 'yyyy-MM-dd', 'en-US');
        this.filter.EndDate = formatDate(lastDay, 'yyyy-MM-dd', 'en-US');

      } else {

        this.filter.InitDate = null;
        this.filter.EndDate = null;

      }

    } else {

      var firstDay = new Date(this.yearDefaultValue, +this.monthDefaultValue - 1, 1);
      var lastDay = new Date(this.yearDefaultValue, +this.monthDefaultValue, 0);

      this.filter.InitDate = formatDate(firstDay, 'yyyy-MM-dd', 'en-US');
      this.filter.EndDate = formatDate(lastDay, 'yyyy-MM-dd', 'en-US');

    }

  }

  getYearValue(event) {

    this.yearDefaultValue = event.option.value;


    if (event.option.value == '0') {

      this.monthDefaultValue = '0';

    } else {

      if (this.monthDefaultValue == '0') {

        var firstDay = new Date(+this.yearDefaultValue, 0, 1);
        var lastDay = new Date(+this.yearDefaultValue, 11, 31);

      } else {

        var firstDay = new Date(+this.yearDefaultValue, +this.monthDefaultValue - 1, 1);
        var lastDay = new Date(+this.yearDefaultValue, +this.monthDefaultValue, 0);

      }

    }

    this.filter.InitDate = event.option.value != '0' ? formatDate(firstDay, 'yyyy-MM-dd', 'en-US') : null;
    this.filter.EndDate = event.option.value != '0' ? formatDate(lastDay, 'yyyy-MM-dd', 'en-US') : null;

  }

  getCampaignType(data: SelectListParams) {

    this.advExpensesService.GetCampaignTypeDashboard(data).subscribe(res => {

      res.sort(function (a, b) {
        if (a.label > b.label) {
          return 1;
        }
        if (a.label < b.label) {
          return -1;
        }
        return 0;
      });

      let result = [];
      result.push({ value: '0', idParent: null, label: 'TODOS OS TIPOS DE CAMPANHA' });
      result.push.apply(result, res);

      this.campaignTypes = result;
      this.campaignTypeDefaultValue = '0';
      this.filter.IdCampaignType = null;

      if (res.length == 1) {

        this.filter.IdCampaignType = res[0].value;
        this.campaignTypeDefaultValue = res[0].value;
        this.getMedia(new SelectListParams({ IdDistrib: this.filter.IdDistributor != null ? [this.filter.IdDistributor] : [], idElement: this.filter.IdCampaignType != null ? [this.filter.IdCampaignType] : [] }));

      }

    });

  }

  getCampaignTypeValue(event) {

    this.filter.IdCampaignType = event.option.value != '0' ? +event.option.value : null;

    this.getMedia(new SelectListParams({ IdDistrib: this.filter.IdDistributor != null ? [this.filter.IdDistributor] : [], idElement: this.filter.IdCampaignType != null ? [this.filter.IdCampaignType] : [] }));
  }

  getMedia(data: SelectListParams) {

    this.advExpensesService.GetMediaDashboard(data).subscribe(res => {

      res.sort(function (a, b) {
        if (a.label > b.label) {
          return 1;
        }
        if (a.label < b.label) {
          return -1;
        }
        return 0;
      });

      let result = [];
      let mediaIdes = res.map(x => x.value);

      result.push({ value: '0', idParent: null, label: 'TODOS OS MATERIAIS' });
      result.push.apply(result, res);

      this.medias = result;
      this.mediaDefaultValue = '0';
      this.filter.IdMedia = null;

      if (res.length == 1) {

        this.filter.IdMedia = res[0].value;
        this.mediaDefaultValue = res[0].value;

      }

      this.getFormat(new SelectListParams({ IdDistrib: this.filter.IdDistributor != null ? [this.filter.IdDistributor] : [], idElement: mediaIdes }));
      // this.getSupport(new SelectListParams({ IdDistrib: this.filter.IdDistributor != null ? [this.filter.IdDistributor] : [], idElement: mediaIdes }));


    });

  }

  getMediaValue(event) {

    this.filter.IdMedia = event.option.value != '0' ? +event.option.value : null;

    if (event.option.value != '0') {
      this.filter.IdCampaignType = this.medias.find(x => x.value == event.option.value).idParent;
      this.campaignTypeDefaultValue = this.filter.IdCampaignType.toString();
    } else {
      this.filter.IdCampaignType = null;
      this.campaignTypeDefaultValue = '0';
    }


    this.getFormat(new SelectListParams({ IdDistrib: this.filter.IdDistributor != null ? [this.filter.IdDistributor] : [], idElement: this.filter.IdMedia != null ? [this.filter.IdMedia] : [] }));
    // this.getSupport(new SelectListParams({ IdDistrib: this.filter.IdDistributor != null ? [this.filter.IdDistributor] : [], idElement: this.filter.IdMedia != null ? [this.filter.IdMedia] : [] }));

  }


  getFormat(data: SelectListParams) {

    this.advExpensesService.GetFormatDashboard(data).subscribe(res => {

      res.sort(function (a, b) {
        if (a.label > b.label) {
          return 1;
        }
        if (a.label < b.label) {
          return -1;
        }
        return 0;
      });

      let result = [];
      result.push({ value: '0', idParent: null, label: 'TODOS OS FORMATOS' });
      result.push.apply(result, res);

      this.formats = result;


      this.formatDefaultValue = '0';
      this.filter.IdFormat = null;

      if (res.length == 1) {
        this.formatDefaultValue = res[0].value;
        this.filter.IdFormat = res[0].value;
      }

    })
  }

  getFormatValue(event) {

    this.filter.IdFormat = event != '0' ? +event.option.value : null;

    if (event.option.value != '0') {

      this.filter.IdMedia = this.formats.find(x => x.value == event.option.value).idParent;
      this.mediaDefaultValue = this.filter.IdMedia.toString();

      this.filter.IdCampaignType = this.medias.find(x => x.value == this.filter.IdMedia.toString()).idParent;
      this.campaignTypeDefaultValue = this.filter.IdCampaignType.toString();

      // this.getSupport(new SelectListParams({ IdDistrib: this.filter.IdDistributor != null ? [this.filter.IdDistributor] : [], idElement: this.filter.IdMedia != null ? [this.filter.IdMedia] : [] }));
    } else {

      this.filter.IdMedia = null;
      this.mediaDefaultValue = '0';

      this.filter.IdCampaignType = null;
      this.campaignTypeDefaultValue = '0';

    }

  }

  // getSupport(data: SelectListParams) {

  //   this.advExpensesService.GetSupportDashboard(data).subscribe(res => {

  //     res.sort(function (a, b) {
  //       if (a.label > b.label) {
  //         return 1;
  //       }
  //       if (a.label < b.label) {
  //         return -1;
  //       }
  //       return 0;
  //     });

  //     let result = [];
  //     result.push({ value: '0', idParent: null, label: 'TODOS OS MEIOS' });
  //     result.push.apply(result, res);

  //     this.supports = result;

  //     this.supportDefaultValue = '0';
  //     this.filter.IdSupport = null;

  //     if (res.length == 1) {
  //       this.supportDefaultValue = res[0].value;
  //       this.filter.IdSupport = res[0].value;
  //     }

  //   });

  // }

  getSupportValue(event) {

    this.filter.IdSupport = event.option.value != '0' ? +event.option.value : null;

    if (event.option.value != '0') {

      this.filter.IdMedia = this.supports.find(x => x.value == event.option.value).idParent;
      this.mediaDefaultValue = this.filter.IdMedia.toString();

      this.filter.IdCampaignType = this.medias.find(x => x.value == this.filter.IdMedia.toString()).idParent;
      this.campaignTypeDefaultValue = this.filter.IdCampaignType.toString();

      this.getFormat(new SelectListParams({ IdDistrib: this.filter.IdDistributor != null ? [this.filter.IdDistributor] : [], idElement: this.filter.IdMedia != null ? [this.filter.IdMedia] : [] }));

    } else {

      this.filter.IdMedia = null;
      this.mediaDefaultValue = '0'

      this.filter.IdCampaignType = null;
      this.campaignTypeDefaultValue = '0';


    }
  }

  getStatus() {

    this.advExpensesService.GetStatusDashboard().subscribe(res => {

      res.sort(function (a, b) {
        if (a.label > b.label) {
          return 1;
        }
        if (a.label < b.label) {
          return -1;
        }
        return 0;
      });

      let result = [];
      result.push({ value: '0', idParent: null, label: 'TODOS OS ESTADOS' });
      result.push.apply(result, res);

      this.status = result;

      this.statusDefaultValue = '0';
      this.filter.IdStatus = null;


    });

  }

  getStatusValue(event) {

    this.filter.IdStatus = event.option.value != '0' ? +event.option.value : null;

  }

  //#endregion

  goToNewExpense() {
    this.router.navigate(["/adv-expense/edit"]);
  }

  //#region BUDGET



  getBudgetData() {


    this.advExpensesService.GetBudgetData(this.filter).subscribe(res => {

      this.budgetModel = res;

      let totalBudgetString = this.budgetModel.TotalBudget;
      let totalBudgetNumber = parseFloat(totalBudgetString.replace(/\s/g, '').replace(',', '.'));


      if (totalBudgetNumber > 0) this.showBudget = true;
      else this.showBudget = false;


      if (this.filter.InitDate)
        this.yearBudget = this.filter.InitDate.substring(0, 4);
      else this.yearBudget = new Date().getFullYear().toString();


    })

    this.checkYearFirstMonth();
  }


  getBudgetDataLastYear(previousYear) {

    var firstDay = new Date(previousYear, 0, 1);
    var initDate = formatDate(firstDay, 'yyyy-MM-dd', 'en-US');

    this.advExpensesService.GetBudgetData({ IdDistributor: this.filter.IdDistributor, DistrictCode: this.filter.DistrictCode, initDate: initDate }).subscribe(res => {


      this.budgetModelLastYear = res;

      let totalBudgetString = this.budgetModelLastYear.TotalBudget;
      let totalBudgetNumber = parseFloat(totalBudgetString.replace(/\s/g, '').replace(',', '.'));

      if (totalBudgetNumber > 0) this.showBudgetLastYear = true;
      else this.showBudgetLastYear = false;


    })
  }


  checkYearFirstMonth() {

    const currentDate = new Date();

    if (currentDate.getMonth() === this.currentMonth) { // Enero es el mes 0 en JavaScript
      this.yearBudgetLastYear = currentDate.getFullYear() - 1;

      this.getBudgetDataLastYear(this.yearBudgetLastYear);

    }

  }

  GetYearMonhlyExcel() {

    this.advExpensesService.GetBudgetYears().subscribe(res => {
      console.log(res)

      this.yearMonthlyExcelData = res;
      this.yearMonthlyExcelSelected = res[res.length - 1].value;


      console.log(this.yearMonthlyExcelSelected)
      console.log(this.yearMonthlyExcelData)

    });
  }

  DownloadMonthlyExcel() {

    Swal.fire({
      allowOutsideClick: false,
      icon: 'info',
      text: 'Espere por favor...'
    });

    Swal.showLoading();

    this.advExpensesService.GetMontlyExcel(this.yearMonthlyExcelSelected).subscribe(blob => {
      Swal.close();
      saveAs(blob, `LIQUIDACIONES-MENSUALES ${this.yearMonthlyExcelSelected}.xlsx`);
    }), (err) => {
      Swal.fire({
        icon: 'error',
        title: 'Error al acceder a la BD',
        text: 'Ocurrió un error'
      });
    }
  }

  getExtraPercent(totalBudget: string, extraSpent: string): number {
    if (!totalBudget || !extraSpent) return 0;
    
    const cleanTotal = totalBudget.toString().replace(/[^0-9,]/g, '').replace(',', '.');
    const cleanExtra = extraSpent.toString().replace(/[^0-9,]/g, '').replace(',', '.');

    let total = parseFloat(cleanTotal);
    let extra = parseFloat(cleanExtra);

    if (isNaN(total) || total === 0) return 0;
    if (isNaN(extra)) return 0;
    return (extra / total) * 100;
  }

  getProgressDataPosition(dataBar, dataEl, percent) {
    dataBar = dataBar as HTMLElement;
    dataEl = dataEl as HTMLElement;
    if (dataBar.offsetWidth < dataEl.offsetWidth + 16) {
      return 8;
    } else {
      return dataBar.offsetWidth - dataEl.offsetWidth - 8;
    }
  }

  //#endregion


}
